import React from "react";
import "../../styles/aboutUs.css";
import About from "../../assets/About.jpg";


const AboutUs = () => {
  return (
    <section className="about-section">
      <div className="about-container">
        
        {/* LEFT SIDE: IMAGE */}
        <div className="about-image-side">
          <img 
            src={About} 
            alt="Student Learning" 
            className="about-img"
          />
        </div>

        {/* RIGHT SIDE: TEXT */}
        <div className="about-text-side">
          <h2 className="about-title">About Us</h2>
          <p className="about-description">
            Madhi Academy is Chennai’s trusted hub for complete learning — from 
            primary school tuition to global professional certifications. Our structured 
            teaching methods, experienced faculty, and modern learning tools ensure 
            every student achieves academic and career excellence.
          </p>
        </div>

      </div>
    </section>
  );
};

export default AboutUs;